<template>
  <tk-flex
    column
    v-if="inviData"
    :style="{ width: width * 2 + 'px', height: height * 2 + 'px' }"
  >
  <div class="bg">
    <tk-flex column center between style="width:100%;height:100%;">
      <div class="head">
        <!-- 头像 -->
        <tk-flex>
          <div class="headImg">
            <tk-image :src='inviData.avatar'></tk-image>
          </div>
          <tk-flex style="padding-left:16px" column>
            <div class="line-clamp-1" style="font-size:32px;width:300px">{{inviData.nickName}}</div>
            <div>我在星居仕邀你一起看装修！</div>
          </tk-flex>
        </tk-flex>
      </div>
      <div style="width:380px;height:380px;border-radius: 48px;overflow: hidden;">
        <tk-image :src="qrImage" style="width:100%;height:100%"></tk-image>
      </div>
      <div>使用微信扫一扫，即可进入小程序</div>
    </tk-flex>
  </div>
  </tk-flex>
</template>
<script>
export default {
  data () {
    return {
      width: 327,
      height: 327,
      getParams: [],
      qrImage: require('../../../assets//image/zhonghui/qr.jpg'),
      inviData: {
        inviImg: [],
        user: {
          avatar: '',
          nickName: ''
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    //   // 0 帖子数据id ，1 设备宽， 2设备高
  },
  methods: {
    async init () {
      // const res = await this.$tkParse.get(`https://cloud.zhituo.mokekeji.com/classes/_User`, {
      //   params: {
      //     where: {
      //       username: '15511346179'
      //     }
      //   }
      // })
      // console.log(res)
      // this.getParams = 'lYk2aR4x6g'
      this.getParams = this.$route.query.params
      await this.getInvi() // 获取用户数据
    },
    async getInvi () {
      const res = await this.$tkParse.get(`https://cloud.zhonghui.mokekeji.com/classes/_User/${this.getParams}`)
      this.inviData = res.data
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
.poster-text {
  font-size: 28px;
  margin-top: 24px;
}
// 只显示两行超出隐藏
.line-clamp-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.bg{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/image/visitingBg.png');
  color: #fff;
  padding: 40px;
  font-size: 24px;
}
.head{
  width: 100%;
}
.headImg{
  width: 80px;
  height: 80px;
  border: 3px solid #fff;
  border-radius: 100%;
  overflow: hidden;
}
</style>
